<template>
  <div id="app">
    <router-view/>
    <!--请求加载框-->
    <div id="ajaxLoader">
      <img src="./assets/ajax-loader.gif" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    width: 100%;
    height: 100%;
  }
  /*** 加载框 ***/
  #ajaxLoader{
    position: fixed;
    z-index: 1002;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color:rgba(1, 1, 1, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
  }
  @media (max-width:800px) {
    #ajaxLoader {
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  [v-cloak] {
    display: none
  }
</style>